import React from 'react';
import { Box, Container, Typography, Button, ThemeProvider } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { WizardStyledBoxContainer, WizardTheme } from "@/styles/theme";
import backgroundImage from '@assets/images/wizard-background.png';

export const SuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <ThemeProvider theme={WizardTheme}>
      <Container maxWidth={false} sx={{ position: "relative", zIndex: 1, m: 0, p: 0 }}>
        <WizardStyledBoxContainer sx={{ opacity: 0.7, m: 0, p: "8px" }}>
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            minHeight="50vh"
            textAlign="center"
          >
            <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h4" sx={{ fontWeight: "bold", color: "primary.main" }} gutterBottom>
              Formulário Enviado com Sucesso!
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Seu formulário foi recebido e está sendo processado.
            </Typography>
            
            {/* <Box mt={4}>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => navigate('/')}
                sx={{ mr: 2 }}
              >
                Voltar para o Início
              </Button>
              <Button 
                variant="outlined"
                onClick={() => navigate(-2)}
              >
                Preencher Outro Formulário
              </Button>
            </Box> */}
          </Box>
        </WizardStyledBoxContainer>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -2,
          }}
        />
      </Container>
      </ThemeProvider>
    </Box>
  );
}; 